import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useContext, useEffect, useMemo, useState } from 'react';
import { EventContext } from '../../event/eventContext';

const FALLBACK = '/ClubAstraLogo.png';

function initialsFor(name) {
  return (
    String(name || 'Brand')
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((word) => word[0])
      .join('')
      .toUpperCase() || 'B'
  );
}

export default function LogoIcon() {
  const ev = useContext(EventContext);
  const brand = (ev && ev.brand) || {};
  const src = brand.icon || brand.logo || FALLBACK;
  const fallbackSrc = brand.logo && src !== brand.logo ? brand.logo : FALLBACK;
  const initials = useMemo(() => initialsFor(brand.shortName || brand.name), [brand.name, brand.shortName]);
  const [activeSrc, setActiveSrc] = useState(src);
  const [imageReady, setImageReady] = useState(false);
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setActiveSrc(src);
    setImageReady(false);
    setImageFailed(false);
  }, [src]);

  return (
    <Box
      sx={{
        height: 32,
        width: 32,
        display: 'inline-grid',
        placeItems: 'center'
      }}
    >
      {!imageFailed && activeSrc ? (
        <Box
          component="img"
          src={activeSrc}
          alt={brand.name || 'Brand logo'}
          onLoad={() => setImageReady(true)}
          onError={() => {
            if (fallbackSrc && activeSrc !== fallbackSrc) {
              setActiveSrc(fallbackSrc);
              setImageReady(false);
              return;
            }
            setImageFailed(true);
          }}
          sx={{
            gridArea: '1 / 1',
            height: 32,
            width: 32,
            display: 'block',
            objectFit: 'contain',
            opacity: imageReady ? 1 : 0,
            transition: 'opacity 160ms ease'
          }}
        />
      ) : null}
      {(imageFailed || !imageReady) && (
        <Typography
          aria-hidden="true"
          sx={{
            gridArea: '1 / 1',
            fontSize: 12,
            fontWeight: 700,
            lineHeight: 1,
            color: 'text.primary'
          }}
        >
          {initials}
        </Typography>
      )}
    </Box>
  );
}
